export default function Team() {
    return (
      <div className="bg-white">
       
      </div>
    )
  }
  